import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import { Loader, Dimmer } from 'semantic-ui-react';
import useTable from '../components/useTable';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import axios from "axios";


const CatalogoModelo = props => {

    let op = require('../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');
    const btnAcepta = useRef();
    const btnCancela = useRef();
    const txtBuscar = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({
        idmodelo: '',
        descripcion: ''});
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CODIGO', textAlign: 'center' },
        { label: 'DESCRIPCION', textAlign: 'center' }
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idmodelo.includes(target.value)
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {

        let campos = 'idmodelo, trim(descripcion) as descripcion';
        let nomtab = 'modelo';
        let orden = 'idmodelo';
    
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                    setRecords(response.data);
                }         
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(()=>{
            setActivate(false); 
        })

    }


    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setRecords([]);
        setValues({
            idmodelo: '',
            descripcion: ''
        });
        setFilterFn({ fn: items => { return items; } });
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }


    const seleccionarModelo = () => {
  
        props.onHideAceptaCatalogo(values);

    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();

        setValues({
            idmodelo: item.idmodelo,
            descripcion: item.descripcion
        });
        btnAcepta.current.focus();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();
                txtBuscar.current.focus();
            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <div className="fw-bold text-light"><h3>Seleccionar Modelo</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>Cargando...</Loader>
                </Dimmer>
                <div className="col-md-12" style={{ marginBottom: "10px" }}>
                    <div className="row">
                        <div className="input-group col-md-6 input-group-sm mb-3">
                            <input type='text'
                                onChange={handleSearch} className="form-control text-uppercase" ref={txtBuscar} />
                            <button className='btn btn-info' style={{ pointerEvents: 'none' }}><i className='fa fa-search'></i></button>
                        </div>
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <TableBody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <TableRow key={index} style={{ padding: "0", cursor: 'pointer', background: values.idmodelo === item.idmodelo ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <TableCell className='py-2 text-center'>{item.idmodelo}</TableCell>
                                        <TableCell className='py-2 text-start'>{item.descripcion}</TableCell>
                                    </TableRow>

                                ))
                            }
                        </TableBody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} className="btn btn-sm btn-success rounded-pill" style={{ margin: "5px" }} onClick={seleccionarModelo}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoModelo;


// WEBPACK FOOTER //
// ./src/catalogos/catalogoModelo.js